import APropos from './APropos';

export default APropos;